import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import PostCardMeta from "components/PostCardMeta/PostCardMeta";
import { Link } from "react-router-dom";
import { IPost } from "../../@core/interfaces/IPost";
import moment from "moment";

export interface Card13Props {
  className?: string;
  post: IPost;
}

const Card13: FC<Card13Props> = ({ className = "", post }) => {
  const { title, id, description , coverURL, createdAt, company } = post;

  return (
    <div className={`nc-Card13 relative flex ${className}`} data-nc-id="Card13">
      <div className="flex flex-col h-full py-2">
        <h2 className={`nc-card-title block font-semibold text-base`}>
          <Link to={`/blog/${id}`} className="line-clamp-2" title={title}>
            {title}
          </Link>
        </h2>
        <span className="hidden sm:block my-3 text-neutral-500 dark:text-neutral-400 ">
          <span className="line-clamp-2"> {description}</span>
        </span>
        <span className="mt-4 block sm:hidden text-sm text-neutral-500 ">
          {moment(createdAt).format("MMM DD, YYYY")}
        </span>
        <div className="mt-auto hidden sm:block">
          <PostCardMeta meta={{ date: moment(createdAt).format("MMM DD, YYYY"), author: company }} />
        </div>
      </div>

      <div
        className={`block relative h-full flex-shrink-0 w-2/5 sm:w-1/3 ml-3 sm:ml-5`}
      >
      <div>
        <NcImage
          containerClassName="absolute inset-0 "
          className="object-cover w-full h-full rounded-xl sm:rounded-3xl"
          src={coverURL}
          alt={title}
        />
      </div>
      </div>
    </div>
  );
};

export default Card13;
